import React, { useState } from "react";
import { Calendar, MultiViewCalendar } from "@progress/kendo-react-dateinputs";
import { Popover } from "@progress/kendo-react-tooltip";
import { Button } from "@progress/kendo-react-buttons";
import { GetISODate } from "../../../../shared/helpers/DateHelpers";
import { IsFirefoxUser } from "shared/helpers/BrowserDetectionHelpers";

export const PaymentDateCell = (props) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarValue, setCalendarValue] = useState(new Date());
  const anchor = React.useRef(null);

  function selectedCalendarCallback(event) {
    setCalendarValue(event.value);
  }

  async function updatePaymentDate(date = null) {
    setShowCalendar(false);
    if (props.onUpdatePaymentDate) {
      await props.onUpdatePaymentDate(props.dataItem.pmid, date);
    }
  }

  return (
    <td className="noPadding" {...props.style}>
      <span>{props.children}</span>
      <span>
        <Button onClick={() => setShowCalendar(!showCalendar)} ref={anchor}>
          <i className={"fa fa-calendar"} />
        </Button>
        <Popover
          show={showCalendar}
          anchor={anchor.current && anchor.current.element}
          position={"bottom"}
        >
          <div
            style={{
              display: "grid",
              justifyItems: "center"
            }}
          >
            {IsFirefoxUser() ?
              <MultiViewCalendar onChange={selectedCalendarCallback} views={1} /> :
              <Calendar onChange={selectedCalendarCallback} />}
            <div>
              <Button
                onClick={() =>
                  updatePaymentDate(GetISODate(calendarValue))
                }
              >
                Submit Payment Date
              </Button>
              <Button onClick={() => updatePaymentDate(null)}>
                Clear Payment Date
              </Button>
              <Button onClick={() => setShowCalendar(false)}>
                Close
              </Button>
            </div>
          </div>
        </Popover>
      </span>
    </td>
  );
};
